import { formatMoney } from './money-formatting.js';
import { sectionRenderer } from '@theme/section-renderer';

// Native facets push history entries, but this theme does not restore their results.
window.addEventListener('popstate', () => {
  const results = document.querySelector('results-list.snoutdaily-collection');
  const sectionId = results?.getAttribute('section-id');
  if (sectionId) sectionRenderer.renderSection(sectionId).catch(() => window.location.reload());
});

// The native sort select and radio group share a name; submit one effective value.
document.addEventListener('formdata', (event) => {
  if (!(event.target instanceof HTMLFormElement) || !event.target.closest('.snoutdaily-collection')) return;
  const sortValues = event.formData.getAll('sort_by');
  if (sortValues.length > 1) event.formData.set('sort_by', sortValues[0]);
});

class SnoutdailyPriceRange extends HTMLElement {
  connectedCallback() {
    this.updateValues();
  }

  commitChange(target) {
    if (!this.updateValues(target)) return;
    const placeholder = this.dataset.moneyFormat.match(/{{\s*\w+\s*}}/)?.[0] || '{{amount}}';
    const currency = this.dataset.currency;
    this.nativeMin.value = Number(this.min.value) === 0 ? '' : formatMoney(Number(this.min.value), placeholder, currency);
    this.nativeMax.value = this.max.value === this.max.max ? '' : formatMoney(Number(this.max.value), placeholder, currency);
    this.nativeMin.dataset.max = formatMoney(Number(this.max.value), placeholder, currency);
    this.nativeMax.dataset.min = formatMoney(Number(this.min.value), placeholder, currency);
    this.nativeMin.dispatchEvent(new Event('change', { bubbles: true }));
  }

  getControls() {
    // Section morphing can replace inputs without reconnecting this element.
    this.min = this.querySelector('[data-bound="min"]');
    this.max = this.querySelector('[data-bound="max"]');
    this.facet = this.closest('price-facet-component');
    this.nativeMin = this.facet?.querySelector('[ref="minInput"]');
    this.nativeMax = this.facet?.querySelector('[ref="maxInput"]');
    return !!(this.min && this.max && this.nativeMin && this.nativeMax);
  }

  updateValues(target) {
    if (!this.getControls()) return false;
    if (Number(this.min.value) > Number(this.max.value)) {
      if (target === this.min) this.min.value = this.max.value;
      else this.max.value = this.min.value;
    }
    for (const bound of ['min', 'max']) {
      const value = formatMoney(Number(this[bound].value), this.dataset.moneyFormat, this.dataset.currency);
      this.querySelector(`[data-range-output="${bound}"]`).textContent = value;
      this[bound].setAttribute('aria-valuetext', value);
    }
    this.min.style.zIndex = Number(this.min.value) === Number(this.max.max) ? '3' : '1';
    return true;
  }
}

if (!customElements.get('snoutdaily-price-range')) {
  customElements.define('snoutdaily-price-range', SnoutdailyPriceRange);
}

// The theme delegates on:change at document capture. Intercept range changes at
// window capture first, then notify the native facet once with updated inputs.
// Delegation also survives section morphs and theme-editor replacement.
for (const type of ['input', 'change']) {
  window.addEventListener(type, (event) => {
    if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'range') return;
    const range = event.target.closest('snoutdaily-price-range');
    if (!(range instanceof SnoutdailyPriceRange)) return;
    if (type === 'change') {
      event.stopPropagation();
      range.commitChange(event.target);
    } else {
      range.updateValues(event.target);
    }
  }, { capture: true });
}
